import { GridColumnMenuProps } from '@progress/kendo-react-grid';
import CustomDropdownFilter from 'src/components/custom-cells/CustomDropdownFilter';

const options = [
  { text: 'Local Upload', operator: 'Local Upload' },
  { text: 'Local Upload (OCR)', operator: 'Local Upload (OCR)' },
  { text: 'Email', operator: 'Email' },
  { text: 'Email (OCR)', operator: 'Email (OCR)' },
  { text: 'SFTP', operator: 'SFTP' },
  { text: 'SFTP (OCR)', operator: 'SFTP (OCR)' },
];

export const SourceFilterMenu = (props: GridColumnMenuProps) => (
  <CustomDropdownFilter {...props} option={options} />
);
